import { WishlistItem } from 'features/wishlist';
import { WISHLIST_ITEM_FLOW } from 'features/wishlist/ducks/actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionType, createAction } from 'typesafe-actions';
import { selectProductPriceCategory } from 'features/product-info';
import {
  selectProductBelong,
  selectProductDiscount,
  selectProductName,
  selectProductPrice,
  selectProductPricePrevious,
} from './selectors';

/**
 * Cобытие должно срабатывать при добавлении товара в список покупок.
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaAddToShoppingList = createAction('GA:addToShoppingList')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'shoppingList';
  productTag?: string | null;
  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productBelong: 'LeroyMerlin' | 'LeroyMerlinMarketplace' | 'Longtail'; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  productPrevPrice: string | null;
  productDiscount: number | null;
}>();

export function* putGaAddToShoppingList(productId: WishlistItem['code']) {
  yield put(
    gaAddToShoppingList({
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'shoppingList',
      productTag: yield call(selectProductPriceCategory),
      productName: yield call(selectProductName),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productId,
      productPrevPrice: yield call(selectProductPricePrevious),
      productDiscount: yield call(selectProductDiscount),
    }),
  );
}

export function* runAddToShoppingListDetector() {
  yield takeEvery(WISHLIST_ITEM_FLOW, function* handle({ payload }: ActionType<typeof WISHLIST_ITEM_FLOW>) {
    const { productId, flowQty } = payload;
    if (flowQty > 0) {
      yield putGaAddToShoppingList(productId);
    }
  });
}
